import "./graphic-picker.style.scss";
import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import DragBannerImage from "../../Assets/organization/banner-upload-placeholder.png"

import RemoveImageCross from "../../Assets/applifecycle/remove-image-cross.svg";

import DevStorageAPI from "../../api/DevStorage";
import { CustomToast } from "../custom-toast/CustomToast";

function FileDropzone({ onFileSelect , fileTypeCheck}) {
  const onDrop = useCallback((acceptedFiles) => {
    console.log(acceptedFiles[0]);
    onFileSelect(acceptedFiles[0]);
    // acceptedFiles.forEach((file) => {
    //   const reader = new FileReader();

    //   reader.onabort = () => console.log("file reading was aborted");
    //   reader.onerror = () => console.log("file reading has failed");
    //   reader.onload = () => {
    //     // Do whatever you want with the file contents
    //     const binaryStr = reader.result;
    //     console.log(binaryStr);
    //   };
    //   reader.readAsArrayBuffer(file);
    // });
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: fileTypeCheck,
    onDrop,
  });

  return (
    <div
      style={{ width: "100%", height: "100%", overflow: "hidden" }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <React.Fragment>
          <div
             style={{ width:"100%",borderRadius:"0px" }}
            className="graphic-select"
          >
            <img alt="img" src={DragBannerImage} />
            <div className="graphic-select-overlay" style={{borderRadius:"0px"}}>
              <p>Drop to upload</p>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          // style={{ height: this.props.height, width: this.props.width }}
          className="graphic-select"
        >
          <img style={{width:"100%"}} alt="img" src={DragBannerImage} />
        </div>
      )}
    </div>
  );
}

export default class BannerPicker extends React.Component {
  /// selectedFileData = undefined;

  constructor(props) {
    super(props);

    this.state = {
      status: 0,
      name: "",
      progress: 0,
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken: "",
      size:0,
      
    };
  }

  generateSAS() {
    var api = new DevStorageAPI();
    api
      .generateSASForAnyDoc({
        type: "organization",
        fileName: this.state.name,
      })
      .then((response) => {
        this.setState({
          sasFileName: response.data.data.fileName,
          sasToken: response.data.data.token,
          sasUrl: response.data.data.url,
          sasUrlWithoutToken: response.data.data.url.replace(
            "?" + response.data.data.token,
            ""
          ),
        });

        this.uploadFile();
      })
      .catch((error) => {
        console.log(error);
        this.showError("Unable to upload please try uploading again");
        CustomToast(error.response.data.message);
      });
  }
  uploadFile() {
    var api = new DevStorageAPI();

    api
      .uploadFile(this.state.sasUrl, this.selectedFileData, (progress) => {
        this.setState({ progress: progress });
        console.log(progress);
      })
      .then((response) => {
        console.log(response);

        this.setState({ status: 2 });

        this.props.onComplete({
          fileName: this.state.sasFileName,
          url: this.state.sasUrlWithoutToken,
          size:this.state.size
        });
      })
      .catch((error) => {
        console.log(error);
        this.props.onComplete({ fileName: "", url: "", size:0 });

        this.showError("Unable to upload please try uploading again");
      });
  }

  resetFile() {
    this.setState({
      status: 0,
      progress: 0,
      name: "",
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken: "",
      size:0,
      
    });
    this.props.onComplete({ fileName: "", url: "" ,size:0});
  }

  handleFileSelect(file) {
   

    if (file === undefined) {
      this.showError("Select Valid File");
      return;
    }
    var fileExtension = "";
      
      if(file.name.lastIndexOf(".") > 0){

        fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase();
      }
      
        if(fileExtension !== "jpg" && fileExtension !== "jpeg" && fileExtension !== "png"){
          CustomToast("Only JPG & PNG are supported");
          this.showError("Only JPG & PNG are supported");
          return;
        }
      var img = new Image();
      img.onload = () => {
        const width  = img.naturalWidth,
              height = img.naturalHeight
              if(width!==this.props.dimensionCheck.width || height!==this.props.dimensionCheck.height){
                // console.log(width,height);
                CustomToast(`Dimension should be ${this.props.dimensionCheck.width}px x ${this.props.dimensionCheck.height}px`);
                this.showError(`Dimension should be ${this.props.dimensionCheck.width}px x ${this.props.dimensionCheck.height}px`);
                return;
              }
              this.resetFile();
              this.selectedFileData = file;
              this.setState({ size:file.size,name:file.name });
              this.generateSAS();
      }
      img.src = window.URL.createObjectURL(file);
     
  }

  showError(msg) {
    this.resetFile();
    this.setState({ errorMsg: msg });
  }

  render() {
    const comp = () => {
      switch (this.state.status) {
        case 0:
          return (
            <FileDropzone
              onFileSelect={(file) => {
                this.handleFileSelect(file);
              }}
              fileTypeCheck={this.props.fileTypeCheck}
            />
          );
        case 1:
          return (
            <div className="file-uploading-container-gpicker">
              Uploading {this.state.progress}%
            </div>
          );
        case 2:
          return (
            <div className="preview-container">
             
                <img
                  alt="img"
                  className="preview-img"
                  src={this.state.sasUrlWithoutToken}
                />
              
              <img
                alt="img"
                className="remove-img"
                onClick={() => this.resetFile()}
                src={RemoveImageCross}
              />
            </div>
          );
        default:
          return <div></div>;
      }
    };

    return (
      <React.Fragment>
        <div
          style={{ width: this.props.width, height: this.props.height, borderRadius:"0px" }}
          className="graphic-select-container-gpicker"
        >
          {comp()}
        </div>

        <span style={{ color: "red" }} className="file-upload-error">
          {this.state.errorMsg}
        </span>
      </React.Fragment>
    );
  }
}
